module.exports = __webpack_public_path__ + "img/illustration-project-empty-state@3x.3eb029bc.png";